import React from 'react';

import GenericNpiLookupComponent from './GenericNpiLookupComponent';
import HarmonyNpiLookupComponent from './HarmonyNpiLookupComponent';
import MelintaNpiLookupComponent from './MelintaNpiLookupComponent';
import VericelNpiLookupComponent from './VericelNpiLookupComponent';
import SobiNpiLookupComponent from './SobiNpiLookupComponent';
import FmiNpiLookupComponent from './FmiNpiLookupComponent';
import AxsomeNpiLookupComponent from './AxsomeNpiLookupComponent';

const npiLookupMapping = {
  harmony: HarmonyNpiLookupComponent,
  melinta: MelintaNpiLookupComponent,
  vericel: VericelNpiLookupComponent,
  vericelburncare: VericelNpiLookupComponent,
  vericelmaci: VericelNpiLookupComponent,
  sobi: SobiNpiLookupComponent,
  foundationmedicineinc: FmiNpiLookupComponent,
  axsomeprograms: AxsomeNpiLookupComponent
};

const renderNpiComponent = (tenant, match) => {
  const NpiLookupComponent = npiLookupMapping[tenant]
    ? npiLookupMapping[tenant]
    : GenericNpiLookupComponent;
  return <NpiLookupComponent match={match} />;
};

export default renderNpiComponent;
